import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Css, Responsive } from '@/ui';
import isPropValid from '@emotion/is-prop-valid';
import { Color } from '../../../styles/Color';
import { RouterLink } from '../link/RouterLink';
import { PageRoutes } from '../../../features/app/pages/domain/constants/PageRoutes';

export const Container = styled.div<{ fullScreenIFrame?: boolean }>`
	position: relative;
	height: ${Css.pxToRem(114)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: ${({ fullScreenIFrame }) =>
			fullScreenIFrame ? `${Css.pxToRem(62)}` : `${Css.pxToRem(52)}`};
	}
`;

export const ScrollingWrapper = styled.div`
	position: absolute;
	width: 100%;
	pointer-events: none;
`;

export const StickyWrapper = styled.div<{ isSticky: boolean }>`
	pointer-events: none;
	z-index: 100;

	${({ isSticky }) => {
		if (!isSticky) {
			return null;
		}

		return `
			position: fixed;
			left: 0;
			right: 0;
			top: 0;
		`;
	}}
`;

export const Wrapper = styled.div<{ isSticky: boolean }>`
	position: relative;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: auto;
	}

	${({ isSticky }) => {
		if (isSticky) {
			return `
				position: fixed;
				left: 0;
				right: 0;
			`;
		}
		return null;
	}}
`;

export const StyledLogoLink = styled(RouterLink, {
	shouldForwardProp: (props) => isPropValid(props),
})<{ invertLogo: boolean; titleTop?: boolean; href: string }>`
	cursor: pointer;
	display: inline-block;
	margin-top: ${Css.pxToRem(32)};
	transition: all 0.3s ease-in-out;
	pointer-events: all;

	${(props) =>
		props.href === PageRoutes.OxdAirport &&
		`
		border-left: thin solid ${Color.PrimaryWhite};
		margin-left: ${Css.pxToRem(10)};
		padding-left: ${Css.pxToRem(15)};
	`}

	${({ invertLogo }) =>
		invertLogo &&
		css`
			svg {
				path:first-of-type {
					fill: ${Color.PrimaryWhite};
				}
			}
		`}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: ${Css.pxToRem(18)};
	}
`;
